module.exports = __webpack_public_path__ + "image/predator_logo2.png";